export default {
  locationUnavailableDialog: {
    title: {
      en: 'Unable to detect your location',
      zh: '未能偵測位置',
    },
    message: {
      en: "We are unable to detect your current location. Please enable location services in your device's settings so we can provide you with more relevant information and services.",
      zh: '我們無法偵測您目前的位置。請在您的裝置設定中啟用定位服務，讓我們能為您提供更多相關資訊及服務。',
    },
    close: {
      en: 'CLOSE',
      zh: '關閉',
    },
    settings: {
      en: 'SETTINGS',
      zh: '設定',
    },
  },
  noAddressDataAvailable: {
    title: {
      en: 'Unable to detect your location',
      zh: '未能偵測位置',
    },
    content: {
      en: 'Pin your new address',
      zh: '釘選您的新地址',
    },
  },
  streetBuildingEstateMessage: {
    content: {
      en: 'We will auto-shorten your address using the {guideline}. You can also input your address in abbreviated form.',
      zh: '我們會以{guideline}自動簡化您的地址。您亦可以縮寫輸入您的地址。',
    },
    guideline: {
      en: 'Address Abbreviation Guideline',
      zh: '地址縮寫指引',
    },
  },
};
